import { render } from "./App.vue?vue&type=template&id=43b42fcc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./styles/global-style.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=43b42fcc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b42fcc"]])

export default __exports__